// eslint-disable-next-line import/no-nodejs-modules
import React from 'react'
import type { FC } from 'react'
import { containers as searchContainers } from '@/checkout-instore-legacy/search'
import AppContainer from '@/checkout-instore-legacy/components/AppContainer'
import SearchBar from '@/checkout-instore-legacy/components/Commons/Topbar/SearchBar'
import { csx, useBreakpoint } from '@vtex/admin-ui'

import {
  TopbarBottomArea,
  TopbarCenterArea,
  TopbarRightArea,
} from '../../../Instore/components/Header/Topbar'
import { ScanButton } from '../../../../core/components/ScanButton'

export const SearchScreen: FC = () => {
  const { breakpoint } = useBreakpoint()

  const isMobileOrTablet = ['mobile', 'tablet'].includes(breakpoint)

  return (
    <>
      {!isMobileOrTablet && (
        <TopbarCenterArea>
          <SearchBar />
        </TopbarCenterArea>
      )}
      <TopbarRightArea>
        <div className={csx({ display: 'flex', justifyContent: 'flex-end' })}>
          <ScanButton color="black" />
        </div>
      </TopbarRightArea>
      {isMobileOrTablet && (
        <TopbarBottomArea>
          <div className={csx({ paddingX: '$space-4' })}>
            <SearchBar />
          </div>
        </TopbarBottomArea>
      )}
      <AppContainer>
        <searchContainers.SearchPageContainer />
      </AppContainer>
    </>
  )
}
